import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
  key: 0
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_LlSelect = _resolveComponent("LlSelect");
  return $data.me ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", null, [_cache[12] || (_cache[12] = _createElementVNode("label", null, "Assigned to", -1)), _createVNode(_component_LlSelect, {
    modelValue: $data.form.account,
    "onUpdate:modelValue": [_cache[0] || (_cache[0] = $event => $data.form.account = $event), _cache[1] || (_cache[1] = $event => $options.emitChange())],
    items: $data.users,
    "item-value": "value",
    "return-object": false,
    placeholder: "Filter by User",
    "is-autocomplete": true,
    clearable: true,
    "hide-details": true
  }, null, 8, ["modelValue", "items"])]), _withDirectives(_createElementVNode("div", null, [_cache[13] || (_cache[13] = _createElementVNode("label", null, "Expense Type", -1)), _createVNode(_component_LlSelect, {
    modelValue: $data.form.expenseType,
    "onUpdate:modelValue": [_cache[2] || (_cache[2] = $event => $data.form.expenseType = $event), _cache[3] || (_cache[3] = $event => $options.emitChange())],
    items: $data.options.expenseTypes,
    "item-value": "value",
    "return-object": false,
    placeholder: "Filter by Expense Type",
    "is-autocomplete": true,
    clearable: false,
    "hide-details": true
  }, null, 8, ["modelValue", "items"])], 512), [[_vShow, $data.showType]]), _createElementVNode("div", null, [_cache[14] || (_cache[14] = _createElementVNode("label", null, "Show Billed", -1)), _createVNode(_component_LlSelect, {
    modelValue: $data.form.billedState,
    "onUpdate:modelValue": [_cache[4] || (_cache[4] = $event => $data.form.billedState = $event), _cache[5] || (_cache[5] = $event => $options.emitChange())],
    items: $data.options.billedOptions,
    "item-value": "value",
    "return-object": false,
    placeholder: "Filter by Billed Type",
    "is-autocomplete": true,
    clearable: false,
    "hide-details": true
  }, null, 8, ["modelValue", "items"])]), _withDirectives(_createElementVNode("div", null, [_cache[15] || (_cache[15] = _createElementVNode("label", null, "Attachment", -1)), _createVNode(_component_LlSelect, {
    modelValue: $data.form.attachments,
    "onUpdate:modelValue": [_cache[6] || (_cache[6] = $event => $data.form.attachments = $event), _cache[7] || (_cache[7] = $event => $options.emitChange())],
    items: $data.options.attachmentOptions,
    "item-value": "value",
    "return-object": false,
    placeholder: "Filter by Attachment",
    clearable: false,
    "hide-details": true
  }, null, 8, ["modelValue", "items"])], 512), [[_vShow, $data.me.features.expenseAttachments]]), _withDirectives(_createElementVNode("div", null, [_createElementVNode("label", null, _toDisplayString($data.me?.company.settings?.labels?.customFlag), 1), _createVNode(_component_LlSelect, {
    modelValue: $data.form.customFlag,
    "onUpdate:modelValue": [_cache[8] || (_cache[8] = $event => $data.form.customFlag = $event), _cache[9] || (_cache[9] = $event => $options.emitChange())],
    items: $data.options.customFlagOptions,
    "item-value": "value",
    "return-object": false,
    placeholder: "Filter by Custom Flag",
    "is-autocomplete": true,
    clearable: false,
    "hide-details": true
  }, null, 8, ["modelValue", "items"])], 512), [[_vShow, $data.me?.company.settings?.labels?.customFlag]]), _withDirectives(_createElementVNode("div", null, [_cache[16] || (_cache[16] = _createElementVNode("label", null, "Show Paid", -1)), _createVNode(_component_LlSelect, {
    modelValue: $data.form.expensePaid,
    "onUpdate:modelValue": [_cache[10] || (_cache[10] = $event => $data.form.expensePaid = $event), _cache[11] || (_cache[11] = $event => $options.emitChange())],
    items: $data.options.paidOptions,
    "item-value": "value",
    "return-object": false,
    placeholder: "Filter by Paid",
    "is-autocomplete": true,
    clearable: false,
    "hide-details": true
  }, null, 8, ["modelValue", "items"])], 512), [[_vShow, $data.form.expenseType === 'Bill']])])) : _createCommentVNode("", true);
}